import _ from 'lodash';
import template from './navCheckout.html';

class NavCheckoutController {
    /*@ngInject*/ 
    constructor() {
    }

    $onInit() {
        
    }

    isCartEmpty() {
        return _.get(this.cart, 'items.length', 0) <= 0;
    }
}

export default {
    template: template,
    bindings: {
        cart: '<',
        onCheckout: '&'
    },
    controller: NavCheckoutController
};